import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';

const ErrorState = ({ message, retryPath }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        p: 3
      }}
    >
      <Box sx={{ mb: 2, color: 'error.main' }}>
        <ErrorIcon sx={{ fontSize: 60 }} />
      </Box>
      <Typography variant="h6" color="error" gutterBottom>
        {message || 'An error occurred'}
      </Typography>
      {retryPath && (
        <Button
          variant="contained"
          onClick={() => navigate(retryPath)}
          sx={{
            backgroundColor: '#591716',
            color: 'white',
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 700,
            px: 4,
            py: 1.5,
            '&:hover': {
              backgroundColor: '#4a1413',
              transform: 'translateY(-1px)',
            },
            '&:disabled': {
              backgroundColor: '#999',
              color: 'white',
              opacity: 0.6
            }
          }}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
};

export default ErrorState; 